'use strict';

var ModalLogin = require('../login-modal');
var { loadUrl } = require('../utils');
var tealium = require('tealium/pages/tealium');
var searchGrid = require('./searchGrid');
var searchWishlist = require('./searchWishlist');
const { safeJSONParse } = require('../util/safeParse');
const { getSearchParams } = require('../util/url');
const setFocus = require('../util/setFocus');
const gridHeaderDisplayName = '.hide-show-filter-header .js-griddisplay-name';
let isModifyProductTilesRunning = false;
const ariaExpanded = 'aria-expanded';

/**
 * Scrolls the window up if applyFilter results with fewer product tiles
 * @param {string} originalCount - result count before ajax call
 * @param {string} newCount - result count after ajax call
 * @returns {boolean} - Indicates if scroll was adjusted.
 */
function adjustScroll(originalCount, newCount) {
    // If the user has scrolled and with fewer results, scroll to the top after the filter has applied
    if (window.scrollY > 0 && parseInt(originalCount, 10) > parseInt(newCount, 10)) {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
        return true;
    }

    return false;
}

/**
* Adjusts the width of a dropdown `<select>` element based on the width of its selected option's text.
* This function dynamically calculates the width of the selected option's text and applies it to the dropdown.
* A small padding is added to the width to ensure the dropdown has adequate spacing.
*
* @function
* @param {jQuery} $select - The jQuery object representing the dropdown `<select>` element to resize.
* @returns {void}
*
* @example
* // Example usage:
* adjustSelectWidth($('#myDropdown'));
*/
function adjustSelectWidth($select) {
    var selectedText = $select.find('option:selected').text();
    var tempSpan = $('<span>').text(selectedText).css({
        visibility: 'hidden',
        'white-space': 'nowrap',
        position: 'absolute',
        'font-family': $select.css('font-family'),
        'font-size': $select.css('font-size'),
        'font-weight': $select.css('font-weight'),
        'line-height': $select.css('line-height'),
        padding: $select.css('padding'),
        border: $select.css('border')
    });

    $('body').append(tempSpan);
    var textWidth = tempSpan[0].getBoundingClientRect().width;
    tempSpan.remove();
    var newWidth = textWidth + 6;
    $select.css('width', newWidth + 'px');
}

/**
 * Edits the current URL based on # of products visible on PGP
 * @param {int} showMoreCount - how many more items will be shown after the click
 * @param {int} productDisplayedCount -  total # of products on the pgp before click
 */
function editURLToEnableBackButtonAnchoring(showMoreCount, productDisplayedCount) {
    const url = new URL(window.location);
    var totalShownCount = showMoreCount + productDisplayedCount;
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(totalShownCount)) {
        url.searchParams.set('start', 0);
        url.searchParams.set('sz', totalShownCount);
        window.history.pushState({}, '', url);
    }
}

/**
 * Create Tealium globals.
 */
function createTealiumGlobals() { // NOSONAR
    // Added for backwards compatibility. Possibly used by an external script (??).
    window.tealiumMasterIds = window.tealiumMasterIds || [];
    window.tealiumProdIds = window.tealiumProdIds || [];
    window.tealiumProdSkus = window.tealiumProdSkus || [];
    window.tealiumProdNames = window.tealiumProdNames || [];
    window.tealiumProdBrands = window.tealiumProdBrands || [];
    window.tealiumProdColors = window.tealiumProdColors || [];
    window.tealiumProdPrices = window.tealiumProdPrices || [];
    window.tealiumProdOriginalPrices = window.tealiumProdOriginalPrices || [];
    window.tealiumProdLists = window.tealiumProdLists || [];
    window.tealiumProdStyles = window.tealiumProdStyles || [];
    window.tealiumProdSizes = window.tealiumProdSizes || [];
    window.tealiumProdWidths = window.tealiumProdWidths || [];
    window.tealiumProdGenders = window.tealiumProdGenders || [];
    window.tealiumProdCategory = window.tealiumProdCategory || [];
    window.tealiumProdPosition = window.tealiumProdPosition || [];
    window.tealiumProdSubCategory = window.tealiumProdSubCategory || [];
    window.tealiumProdLine = window.tealiumProdLine || [];
    window.tealiumProdSilhouette = window.tealiumProdSilhouette || [];

    // Product impressions.
    window.productImpressions = {
        tealiumPIProdIds: [],
        tealiumMasterIds: [],
        tealiumPIProdNames: [],
        tealiumPIProdBrands: [],
        tealiumPIProdPrices: [],
        tealiumPIProdCategory: [],
        tealiumPIProdPosition: [],
        tealiumPIProdSubCategory: []
    };
}

/**
 * Handle product impressions.
 */
function handleProductImpressions() { // NOSONAR
    createTealiumGlobals();

    // Collect data.
    const containerElement = document.querySelector('.container.search-results');
    const containerDataSet = containerElement ? containerElement.dataset : {};
    const subCategory = containerDataSet.analyticsSubCategory || '';
    const impressionElements = document.querySelectorAll('[data-tealium-product-tile-data]:not([data-handled])');

    for (let i = 0; i < impressionElements.length; i += 1) {
        const element = impressionElements[i];
        element.setAttribute('data-handled', 'true');

        const dataString = element.getAttribute('data-tealium-product-tile-data') || '';
        const { result } = safeJSONParse(dataString);

        if (!result || typeof result !== 'object') {
            // eslint-disable-next-line no-continue
            continue;
        }

        // Add extra information.
        const tileContainerElement = element.closest('.pgptiles');
        const position = tileContainerElement ? tileContainerElement.getAttribute('data-product-position') || '' : '';

        result.position = /^\d+$/.test(position) ? position : null;
        result.subCategory = subCategory;

        // Fill globals.
        window.tealiumMasterIds.push(String(result.masterProductId || null));
        window.tealiumProdIds.push(String(result.pid || null));
        window.tealiumProdSkus.push(String(result.pid || null));
        window.tealiumProdNames.push(String(result.productName || null));
        window.tealiumProdBrands.push(String(result.brand || null));
        window.tealiumProdColors.push(String(result.color || null));
        window.tealiumProdPrices.push(String(result.price || null));
        window.tealiumProdSizes.push(String(result.size || null));
        window.tealiumProdWidths.push(String(result.width || null));
        window.tealiumProdGenders.push(String(result.gender || null));
        window.tealiumProdOriginalPrices.push(String(result.originalPrice || null));
        window.tealiumProdLists.push(String(result.list || 'null').toLowerCase());
        window.tealiumProdStyles.push(String(result.style || null));
        window.tealiumProdCategory.push(String(result.category || null));
        window.tealiumProdPosition.push(String(result.position || null));
        window.tealiumProdSubCategory.push(String(result.subCategory || null));
        window.tealiumProdLine.push(String(result.line || null));
        window.tealiumProdSilhouette.push(String(result.silhouette || null));

        window.productImpressions.tealiumPIProdIds.push(String(result.pid || null));
        window.productImpressions.tealiumMasterIds.push(String(result.masterProductId || null));
        window.productImpressions.tealiumPIProdNames.push(String(result.productName || null));
        window.productImpressions.tealiumPIProdBrands.push(String(result.brand || null));
        window.productImpressions.tealiumPIProdCategory.push(String(result.category || null));
        window.productImpressions.tealiumPIProdSubCategory.push(String(result.subCategory || null));
        window.productImpressions.tealiumPIProdPosition.push(String(result.position || null));
        window.productImpressions.tealiumPIProdPrices.push(String(result.price || null));
    }

    if (document.querySelectorAll('.result-count.col.no-results-section').length === 0 && tealium.ajaxProductImpressionTriggerEvent) {
        tealium.ajaxProductImpressionTriggerEvent(window.productImpressions);
    }
}

const mainContainerSelector = '.container.search-results';
const ariaHidden = 'aria-hidden';
const modalOpen = 'modal-open';
const refinementBar = '.refinement-bar';
const tabPane = '.tab-pane.active';
const modalBackground = '.modal-background';
const modalActive = document.getElementsByClassName('refinement active');

/**
 * Handle modal close.
 */
function closeCurrentModal() {
    $(modalBackground).css('display', 'none');
    const $currentOpenModal = $('.nb-modal-view');
    $currentOpenModal.css({ '-webkit-transform': 'translateY(100%)' });
    $currentOpenModal.siblings().attr(ariaHidden, false);
    $currentOpenModal.closest('.row').siblings().attr(ariaHidden, false);
    $currentOpenModal.find('button.close').attr(ariaExpanded, false);
    $currentOpenModal.closest(tabPane).siblings().attr(ariaHidden, false);
    $currentOpenModal.closest(mainContainerSelector).siblings().attr(ariaHidden, false);
    // This is for desktop quick view
    $('.product-quickview-modal.nb-modal-view').addClass('hidden');
    document.body.classList.remove(modalOpen, 'nb-modal-display');

    if ($currentOpenModal.attr('style')) {
        $currentOpenModal.removeAttr('style');
    }

    while (modalActive.length > 0) {
        modalActive[0].classList.remove('active');
    }
}

/**
 * Perform certain expensive actions with small delay.
 */
function delayedGridMutationActions() {
    setTimeout(() => {
        $('body').trigger('initSlickSlider');

        searchWishlist.update();
    }, 50);

    setTimeout(() => {
        handleProductImpressions();
    }, 75);
}

/**
 * Get selected sorting rule.
 * @returns {Object} - URL and sorting rule name.
 */
function getSelectedSortingRule() {
    const sortDropDown = document.querySelector('.desktop-sort select[name="sort-order"]');
    const url = sortDropDown ? sortDropDown.value : null;
    const params = getSearchParams(url);

    return {
        url,
        sortingRule: params.srule || null
    };
}

/**
 * Set URL parameter.
 * @param {string} inputUrl - URL to manipulate.
 * @param {Object} params - Key value pairs.
 * @returns {string} - Resulting URL.
 */
function setUrlParameters(inputUrl, params) {
    try {
        const fullUrl = inputUrl.indexOf('http') === 0 ? inputUrl : window.location.origin + inputUrl;
        const url = new URL(fullUrl);

        Object.keys(params).forEach((name) => {
            const value = params[name];

            if (value) {
                url.searchParams.set(name, value);
            } else if (url.searchParams.has(name)) {
                url.searchParams.delete(name);
            }
        });

        return url.toString();
    } catch (e) {
        return inputUrl;
    }
}
/**
 * Method to update the sort refinement in mobile view
 * @param {string} srule selected sort id
 */
function updateMobileSortRefinement(srule) {
    $('.sort-by-mobile li').removeClass('filter-row-items-selected');
    var $li = $('.sort-by-mobile li');
    for (var i = 0; i < $li.length; i += 1) {
        var $currentLI = $($li[i]);
        if ($currentLI && $currentLI.length) {
            var value = $currentLI.attr('value');
            value = decodeURIComponent(value);
            if (value.indexOf(srule) > -1) {
                $currentLI.addClass('filter-row-items-selected');
                break;
            }
        }
    }
}
/**
 * updating the product grid section base on the sorting options
 * moved to separate function to achieve the mobile design and functionality
 * @param {Object} sortOption - object of sort by option selected/checked
 * @param {string} currentUrl - current url to be upadted witth sort query param
 * @returns{undefined}
 */
function sortProducts(sortOption, currentUrl) {
    $(sortOption).trigger('search:sort', sortOption.value);
    const $sortSelect = $(sortOption);
    const onSelectFilter = $('.desktop-sort > select.sort-order > option:selected').val();
    const ajaxUrl = sortOption.value || $sortSelect.attr('value') || onSelectFilter;
    adjustSelectWidth($(sortOption));

    if (ajaxUrl) {
        $.spinner().start();
        $.ajax({
            url: ajaxUrl,
            method: 'GET',
            success: function (response) {
                searchGrid.cancelRequests();

                $('.product-grid').empty().html(response);
                $.spinner().stop();

                const title = $('#product-search-results').data('plp-back-title');

                const sortingRuleParams = getSearchParams(ajaxUrl);
                const newUrl = setUrlParameters(currentUrl, {
                    start: null,
                    sz: null,
                    srule: sortingRuleParams.srule || null
                });

                window.history.replaceState({ plpState: true }, title, newUrl);
                searchGrid.update(false, 'sortProducts');
                updateMobileSortRefinement(sortingRuleParams.srule);

                delayedGridMutationActions();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @param {boolean} isSelect - To identify DOM to be updated is select field
 * @return {undefined}
 */
function updateDom($results, selector, isSelect) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    if ($results.find('.js-display-leftnav-reset').val() === 'true') {
        $('.js-leftnav-resetlink').removeClass('d-none');
    } else {
        $('.js-leftnav-resetlink').addClass('d-none');
    }

    if (isSelect) {
        window.initSelectElements();
    }

    $('.desktop-sort select[name=sort-order]').on('change', function (e) {
        e.preventDefault();
        sortProducts(this, window.location.href);
    });
    $('.sort-by-mobile').on('click', '.sort-by-option', function () {
        $(this).addClass('active').siblings().removeClass('active');
        sortProducts(this, window.location.href);
    });
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.desktop .refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr(ariaExpanded, 'true');
    });

    if ($('.hide-filters .filter-hide').hasClass('active')) {
        $results.find('.filter-tabs-js').removeClass('d-lg-block');
    } else if ($('.hide-filters .filter-show').hasClass('active')) {
        $results.find('.filter-tabs-js').addClass('d-lg-block');
    }

    updateDom($results, '.grid-header');
    updateDom($results, '.refinements');
}

/**
 * Keep Sortr aas per initla selection after results are fetched
 *
 * @param {Object} results - jQuery DOM element
 * @param {string} selectedSort - Initial sort value
 * @param {string} selector - sort selector
 * @return {undefined}
 */
function handleSort(results, selectedSort, selector) {
    var optionSelector = '.desktop-sort select[name="sort-order"] option[data-id="' + selectedSort + '"]';
    results.find(optionSelector).attr('selected', true);
    updateDom(results, selector, true);
}

/**
 * Update SEO widget content after applying/deselecting a filter.
 * @param {Object} $results - jQuery object.
 * @param {string} selectedSort - Sorting rule.
 * @param {string} selector - Selector
 */
function handleSeoWidget($results, selectedSort, selector) {
    const $updates = $results.find(selector);

    const html = ($updates.html() || '').trim();
    const source = $updates.attr('data-source') || 'N/A';

    const $container = $(selector);
    $container.empty().html(html);
    $container.attr('data-source', source);
}

/**
 * Update the filter list based on the response HTML
 *
 * @param {string} response - The response HTML
 */
function updateFilterList(response) {
    $('#filter-list-container .btn.filter-results').each(function () {
        if (!$(this).hasClass('always-visible')) {
            $(this).closest('li').remove();
        }
    });

    const newListItems = $(response).find('#filter-list-container').children().filter(function () {
        return !$(this).find('.btn').hasClass('always-visible');
    });

    const lastAlwaysVisibleItem = $('#filter-list-container .btn.always-visible').closest('li').last();

    // Append new list items after the last always-visible items
    for (let i = newListItems.length - 1; i >= 0; i -= 1) {
        const newItem = $(newListItems[i]);
        if (lastAlwaysVisibleItem.length) {
            newItem.insertAfter(lastAlwaysVisibleItem);
        } else {
            $('#filter-list-container').prepend(newItem);
        }
    }
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @param {string} selectedSort - Initial sort value
 * @return {undefined}
 */
function parseResults(response, selectedSort) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
        '.sort-by-mobile': handleSort,
        '.desktop-sort': handleSort,
        '.pgp-seo-content': handleSeoWidget
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.breadcrumb.js-breadcrumbslist',
        '.js-griddisplay-name',
        '.sort-by-mobile',
        '.desktop-sort',
        '.pgp-banner',
        '.mobile-footer-count',
        '.grid-filter-breadcrumbs',
        '.refinement-tabs'
    ].forEach(function (selector) {
        var update = true;
        if (selector === '.pgp-banner') {
            var enhancedGB = $('.enhanced-guided-buying');
            update = !(enhancedGB && enhancedGB.length);
        }
        if (update) {
            updateDom($results, selector);
        }
    });
    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results, selectedSort, selector);
    });
    updateFilterList(response);
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
            handleProductImpressions();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Call MyFit  login Modal
 * @param {string} url - url for ajax
 * @param {boolean} set MyFit if true else trigger login modal
 */
function myFitLogin() {
    var loginUrl = $('.lg-valid').data('url');
    $.spinner().start();
    $.ajax({
        url: loginUrl,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            if (!data.isLoggedIn) {
                $.spinner().stop();
                $(document).trigger('login-modal-open', ['login_popupin', 'myfit_search']);
                var myFitHeading = $('.myfit-heading').val();
                $('.myfit-login').val(true);
                var $pgp = $('#unique-id-pgp');
                $pgp.modal('show').find('.modal-body').spinner().start();
                loadUrl($pgp[0]).then(function () {
                    $.spinner().stop();
                });
                $pgp.find('.login-heading').empty()
                    .html(myFitHeading);
            } else {
                var myfitprofile = $('.set-myfit').attr('href');
                window.location.href = myfitprofile;
            }
        },
        error: function () {
            $.spinner().stop();
            window.location.reload();
        }
    });
}

/**
 * Adjust scroll after adding items on clicking load previous button.
 * @param {Object} response - Response info.
 * @param {HTMLElement} firstProduct - First product before adding items.
 * @param {number} firstProductTop - First product top position before adding items.
 */
function adjustScrollAfterAddingItems(response, firstProduct, firstProductTop) {
    if (response.direction !== -1 || !firstProduct) {
        return;
    }

    var newFirstProductTop = firstProduct.getBoundingClientRect().top;
    var scrolledHeight = newFirstProductTop - firstProductTop;
    window.scrollTo(0, window.pageYOffset + scrolledHeight);
}

/**
 * Handle the loading of a next or previous page in the grid.
 * @param {Object} response - Response data.
 */
function handlePageLoaded(response) {
    var isPagingEnabled = searchGrid.isPagingEnabled();
    var firstProduct = document.querySelector('.pgptiles');
    var firstProductTop = firstProduct ? firstProduct.getBoundingClientRect().top : 0;

    response.$replaceElement.replaceWith(response.html);

    if ($('.listview-active').hasClass('active')) {
        $('body').find('.product-grid .pgptiles').removeClass('col-6').addClass('col-12');
    }

    adjustScrollAfterAddingItems(response, firstProduct, firstProductTop);

    delayedGridMutationActions();

    $.spinner().stop();

    if (response.direction === 1 && !isPagingEnabled) {
        var $button = response.$replaceElement.find('button');
        var showMoreCount = parseInt($button.data('show-more-count'), 10);
        var productDisplayedCount = parseInt($button.data('showing-count'), 10);

        // Update URL with new start,sz values.
        editURLToEnableBackButtonAnchoring(showMoreCount, productDisplayedCount);
    }
}

/**
 * Handle refinements tooltip display
 * @param {string} filterID - filterID
 * @param {number} mouseY - mouseY
 * @param {number} mouseX - mouseX
 */
function tooltipDisplay(filterID, mouseY, mouseX) {
    var tooltipContainer = $('#filter-tooltip-info');
    var tooltip = tooltipContainer.find('.tooltip-info');
    var tooltipYPosition;
    var tooltipXPosition;
    $(tooltip).each(function () {
        if ($(this).attr('id') === filterID) {
            $(this).removeClass('d-none');
        }
    });

    tooltipContainer.css({ top: -500, left: mouseX }).removeClass('d-none');
    tooltipYPosition = (mouseY - tooltipContainer.height()) - 30;
    tooltipXPosition = mouseX - 52;
    tooltipContainer.css({ top: tooltipYPosition, left: tooltipXPosition });
}

/**
 * Handle refinements tooltip close
 * @param {Object} tooltipModal - Response data.
 */
function tooltipClose(tooltipModal) {
    $(tooltipModal).addClass('d-none');
    $(tooltipModal).find('span').addClass('d-none');
    $(tooltipModal).removeClass('set');
}

/**
 * Handle Filter Recommendations.
 * @param {JQuery} $element - the jquery element that has the click event attached
 */
function filterRecommendationsOnPGP($element) {
    if (window.sitePrefs.enableFilterRecommendations && window.sitePrefs.enableFilterRecommendationsPGP) {
        var $refinement = $element.closest('.refinement');

        if (($refinement.hasClass('refinement-mensfootwearsize') || $refinement.hasClass('refinement-womensfootwearsize') || $refinement.hasClass('refinement-unisexfootwearsize')) && !$element.hasClass('selected')) {
            var size = $element.find('.js-filter-label').text().trim();
            var gender;

            if ($refinement.hasClass('refinement-mensfootwearsize')) {
                gender = 'men';
            } else if ($refinement.hasClass('refinement-womensfootwearsize')) {
                gender = 'women';
            } else if ($refinement.hasClass('refinement-unisexfootwearsize')) {
                gender = 'unisex';
                size = size.replace('M', '').split('/')[0].trim();
            }
            $(document).trigger('controlSlick');
            $('body').trigger('filterEinsteinRecommendations', 'size=' + size + '&gender=' + gender);
        }
    }
}

/**
 * Back to Top Button on mobile function
 */
function backtoTop() {
    const backtoTopButton = $('.back-to-top-button');
    if (!backtoTopButton) {
        return;
    }
    window.addEventListener('scroll', function () {
        if (window.scrollY >= 20) {
            backtoTopButton.removeClass('d-none');
        } else {
            backtoTopButton.addClass('d-none');
        }
    });
    backtoTopButton.on('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}

/**
 * changing search box to show & instead of &amp;
 */
function decodeSearch() {
    var searchString = ($('.search-field').attr('value'));
    if (searchString.includes('&amp;')) {
        var newSearchString = searchString.replace(/&amp;/g, '&');
        $('.search-field').attr('value', newSearchString);
    }
}

/**
 * Updates the filter count based on the number of selected filters
 */
function updateFilterCount() {
    const selectedCount = $('.btn-filter-breadcrumb.selected').length;
    $('.total-filter-count').text(selectedCount > 0 ? `(${selectedCount})` : '');

    $('.refinements.desktop .card.refinement').each(function () {
        const filterParentAttr = $(this).data('refinement');
        const filterBtn = $('[data-refinement-btn="' + filterParentAttr + '"]');
        const count = $(this).find('.filter-row-items-selected').length;
        filterBtn.find('.filter-count').text(count > 0 ? `(${count})` : '');
    });
}

/**
* Gets indexes of product tiles to enlarge
* @returns {Array} - Array of content slot indexes
*/
function getContentSlotIndexes() {
    let slots = [];
    $('.pgptiles:has(.storepage)').each(function () {
        const value = $(this).attr('style');
        const slotIndex = parseInt(value.match(/\d+/)[0], 10);
        slots.push(slotIndex);
    });

    return slots;
}

/**
* Finds which slots to enlarge
* @param {Array} contentSlotIndexes - Indexes of content slots
* @param {number} length - Number of tiles
* @param {number} startingIndex - Index to start from
* @returns {Array} - Array of indexes to modify
*/
function generateSequence(contentSlotIndexes, length, startingIndex) {
    let frequency = 7;
    let indexesToModify = [];
    let currentIndex = startingIndex;

    for (let i = 0; i <= length / (frequency - 1); i += 1) {
        indexesToModify.push(currentIndex);

        // Determine the next increment value
        let nextIncrement = frequency;
        for (let j = currentIndex; j < currentIndex + frequency; j += 1) {
            if (contentSlotIndexes.includes(j + 1)) {
                nextIncrement = frequency - 1;
                break;
            }
        }

        currentIndex += nextIncrement;
    }

    return indexesToModify;
}

/**
* Modifies the product tiles
*/
function modifyProductTiles() {
    isModifyProductTilesRunning = true;
    let contentSlotIndexes = getContentSlotIndexes();
    let startingIndex;
    let hasGridSlot1 = $('.pgptiles[style="order: 0;"]:has(.storepage)').length;

    if (hasGridSlot1) {
        startingIndex = 1;
    } else {
        startingIndex = 2;
    }

    // eslint-disable-next-line sonarjs/no-duplicate-string
    const $tiles = $('.pgptiles:has(.product-tile)');
    let indexesToModify = generateSequence(contentSlotIndexes, $tiles.length, startingIndex);
    $tiles.each(function (index) {
        // Reset Tiles if returning from PDP and loading tiles w/ "Load Previous"
        $(this).removeClass('col-12').addClass('col-6');
        if (index === startingIndex || indexesToModify.includes(index)) {
            $(this).removeClass('col-6').addClass('col-12').addClass('enlarged-mobile-image');
        }
    });
    isModifyProductTilesRunning = false;
}

/**
 * Enlarges specific product tile images on mobile
 */
function enlargeMobileImages() {
    let frequency = 7;
    const productGrid = document.querySelector('#product-search-results .product-grid');

    // Observe the PGP for new / removed product tiles.
    const callback = (mutationsList) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const mutation of mutationsList) {
            // eslint-disable-next-line sonarjs/no-collapsible-if
            if (mutation.type === 'childList' && mutation.addedNodes.length && !isModifyProductTilesRunning) {
                if ($('.pgptiles:has(.product-tile)').length > frequency) {
                    modifyProductTiles();
                }
            }
        }
    };

    const observer = new MutationObserver(callback);
    const observerConfig = { attributes: true, attributeFilter: ['class'], childList: true };

    // Modify on load and observe
    if ($('.pgptiles:has(.product-tile)').length > frequency) {
        modifyProductTiles();
    }

    observer.observe(productGrid, observerConfig);
}

/**
 * This function checks a DOM element for a data property that indicates
 * whether or not to enlage the images on mobile
 */
function checkDomForCustomCatFlag() {
    var hasCategoryFlag = $('#product-search-results').data('enlargeProductImages');
    if (hasCategoryFlag) {
        enlargeMobileImages();
    }
}

/**
 * This function updates the source attributes
 * @param {JQuery} $source - the jquery element that has the mobile image source
 * @param {string} attribute - the attribute to update
 */
function updateSrcSetAttributes($source, attribute) {
    if ($source.attr(attribute)) {
        var srcsetAttr = $source.attr(attribute).replaceAll('460', '920').replaceAll('230', '460');
        $source.attr(attribute, srcsetAttr);
    }
}

/**
 * This function updates the enlarged mobile images with higher reolution images
 */
function updateEnlargedMobileImages() {
    const $enlargedImages = $('.enlarged-mobile-image');

    $enlargedImages.each(function (index, element) {
        var $element = $(element);
        var $source = $element.find('.image-container picture.firstImage source:eq(0)');
        updateSrcSetAttributes($source, 'srcset');
        updateSrcSetAttributes($source, 'data-srcset');
    });
}

module.exports = {
    init: function () {
        if ($('.js-display-leftnav-reset').val() === 'true') {
            $('.js-leftnav-resetlink').removeClass('d-none');
        } else {
            $('.js-leftnav-resetlink').addClass('d-none');
        }
        adjustSelectWidth($('.js-sort-by-dropdown'));

        $(window).on('load', function () {
            handleProductImpressions();
            updateFilterCount();
            updateEnlargedMobileImages();
        });
        searchGrid.onScrollAdd = handlePageLoaded;
        searchGrid.init();

        searchWishlist.init();
        decodeSearch();
    },
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $(mainContainerSelector).on('click', 'button.filter-results', function (event) {
            event.stopPropagation();
            document.body.classList.add(modalOpen, 'nb-modal-display');

            const $modalBackground = $(modalBackground);
            $modalBackground.css('display', 'block');

            const $refinementBar = $(refinementBar);
            if ($refinementBar.attr('style')) {
                $refinementBar.removeAttr('style');
            }

            $refinementBar.css({ '-webkit-transform': 'translateY(16%)' });
            $refinementBar.siblings().attr(ariaHidden, true);
            $refinementBar.closest('.row').siblings().attr(ariaHidden, true);
            $refinementBar.closest(tabPane).siblings().attr(ariaHidden, true);
            $refinementBar.closest(mainContainerSelector).siblings().attr(ariaHidden, true);
            $refinementBar.find('button.close').attr(ariaExpanded, true);

            const griddisplayName = $(gridHeaderDisplayName).text() || '';
            $(document).find(gridHeaderDisplayName).empty().text(griddisplayName);

            if ($(this).attr('data-refinement-btn')) {
                var filterDataAttr = $(this).attr('data-refinement-btn');
                var filterRefinement = $refinementBar.find('.refinement');
                var refinementContent = $refinementBar.find('.refinement-content');
                var offsetHeader;

                $(filterRefinement).each(function () {
                    if (filterDataAttr === $(this).attr('data-refinement')) {
                        refinementContent.scrollTop(0);
                        offsetHeader = $(this).position().top - 58;
                        refinementContent.scrollTop(offsetHeader);
                        $(this).addClass('active');
                        $(this).find('button.title').attr(ariaExpanded, 'true');
                    }
                });
            }

            setFocus($('.refinement-bar .close'));
        });
    },
    closeModalFromBackground: function () {
        $(modalBackground).on('click', function (e) {
            e.stopPropagation();
            closeCurrentModal();
        });
    },
    closeRefinements: function () {
        // Refinements close button
        $(mainContainerSelector).on('click', '.refinement-bar button.close, .pCount-btn', function (e) {
            e.stopPropagation();
            closeCurrentModal();
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            if ($(refinementBar).attr('style')) {
                $('body').removeClass(modalOpen);
                $('.refinement-bar, .modal-background').hide();
                $(refinementBar).siblings().attr(ariaHidden, false);
                $(refinementBar).closest('.row').siblings().attr(ariaHidden, false);
                $(refinementBar).closest(tabPane).siblings().attr(ariaHidden, false);
                $(refinementBar).closest(mainContainerSelector).siblings().attr(ariaHidden, false);
            }
        });
    },

    refinementTooltip: function () {
        var mouseX;
        var mouseY;
        var tooltipModal = $('#filter-tooltip-info');
        var refinementContainer = $(refinementBar).find('.refinement-content');
        $(document).mousemove(function (e) {
            mouseX = e.clientX;
            mouseY = e.clientY;
        });

        $(refinementBar).on('click', '.filter-tooltip', function (event) {
            event.stopPropagation();
            if ($(tooltipModal).hasClass('set')) {
                tooltipClose(tooltipModal);
            } else if ($(tooltipModal).hasClass('set d-none')) {
                let filterID = $(this).attr('id');
                tooltipDisplay(filterID, mouseY, mouseX);
            } else {
                let filterID = $(this).attr('id');
                tooltipDisplay(filterID, mouseY, mouseX);
                $(tooltipModal).addClass('set');
            }
        });

        $(refinementBar).off('click', '.filter-tooltip', function () {
            tooltipClose(tooltipModal);
        });

        $(refinementBar).on('mouseenter', '.filter-tooltip', function (event) {
            event.preventDefault();
            let filterID = $(this).attr('id');
            tooltipDisplay(filterID, mouseY, mouseX);
        });

        $(refinementBar).on('mouseout', '.filter-tooltip', function () {
            tooltipClose(tooltipModal);
        });

        $(refinementBar).on('scroll', function () {
            tooltipClose(tooltipModal);
        });

        $(refinementContainer).on('scroll', function () {
            tooltipClose(tooltipModal);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.desktop-sort select[name=sort-order], .sort-by-mobile').on('change', function (e) {
            e.preventDefault();
            sortProducts(this, window.location.href);
        });
    },

    sortUpdateSelectedState: function () {
        var open = false;
        var $sortOrder = $("select[name='sort-order']");
        $sortOrder.on('click', function () {
            open = true;
            $sortOrder.toggleClass('open');
            $sortOrder.find('option').removeClass('font-weight-bold selected');
            $sortOrder.find('option:selected').addClass('font-weight-bold selected');
        });

        // fire only if menu is already in "open" state
        $sortOrder.on('blur', function () {
            if (open) {
                open = false;
                $sortOrder.removeClass('open');
            }
        });

        // on ESC key toggle the "open" variable only if menu is in "open" state
        $(document).keyup(function (e) {
            if (e.keyCode === 27 && open) {
                open = false;
                $sortOrder.removeClass('open');
            }
        });
    },

    showMore: function () {
        // Show more products
        $(mainContainerSelector).on('click', '.show-more button, .show-previous button', function (e) {
            e.stopPropagation();
            e.preventDefault();

            var pageUrl = $(this).data('url');
            var direction = this.closest('.show-more') ? 1 : -1;

            if (!pageUrl) {
                return;
            }

            // Only show the spinner when page has not been fetched yet.
            if (!searchGrid.hasPage(pageUrl)) {
                $.spinner().start();
            }

            $(this).trigger('search:showMore', e);

            searchGrid.getPage(pageUrl, direction)
                .done(function (response) {
                    handlePageLoaded(response);
                }).fail(function () {
                    $.spinner().stop();
                });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(mainContainerSelector).on(
            'click',
            '.section-based-clearall,.selected-refinements-gridtop .selected-value,.refinements li button, .refinements li a, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .selected-filter-breadcrumbs button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                var $this = $(this);
                $.spinner().start();
                $this.trigger('search:filter', e);

                let url = $this.data('href') || $this.attr('href');

                // navigate the page if a subcategory refinement
                if (this.classList.contains('tl_filter_categories')) {
                    window.location.href = url;
                    return;
                }

                if (window.filterTriggerEvent && (this.classList && !this.classList.contains('clear-filter') && !this.classList.contains('reset'))) {
                    setTimeout(() => {
                        window.filterTriggerEvent(url, e);
                    }, 5);
                }

                const { sortingRule } = getSelectedSortingRule();

                const ajaxUrl = setUrlParameters(url, {
                    ajaxrequest: 'true',
                    srule: sortingRule
                });

                const addressUrl = setUrlParameters(url, {
                    srule: sortingRule
                });

                $.ajax({
                    url: ajaxUrl,
                    method: 'GET',
                    success: function (response) {
                        searchGrid.cancelRequests();
                        $.spinner().stop();

                        var originalCount = $('.hide-show-filter-header .pgp-count').text();
                        var sortValue = $('.desktop-sort select[name="sort-order"] option:selected').attr('data-id');

                        parseResults(response, sortValue);

                        var griddisplayName = '';
                        var pCount = '';
                        griddisplayName = $('.hide-show-filter-header  .js-griddisplay-name').text();
                        $(document).find(gridHeaderDisplayName).empty().text(griddisplayName);
                        pCount = $('.hide-show-filter-header  .pgp-count').text();
                        $(document).find('.hide-show-filter-header .pgp-count, .pgp-grids .pgp-items').empty().text(pCount);

                        var $titleResponse = $(response);
                        var title = $titleResponse.find('#product-search-results').data('plp-back-title');
                        document.title = title;

                        window.history.replaceState({ plpState: true }, title, addressUrl);

                        delayedGridMutationActions();

                        var scrollAdjusted = adjustScroll(originalCount, pCount);

                        // Re-initializes the Shop The Look grid tile after clicking a refinement
                        $(document).trigger('search:applyingFilter');

                        searchGrid.update(scrollAdjusted, 'applyFilter');
                        updateFilterCount();
                        filterRecommendationsOnPGP($this);
                        $('body').trigger('carousels:reinit');
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        );
    },
    showContentTab: function () {
        // Display content results from the search
        $(mainContainerSelector).on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $(mainContainerSelector).on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },
    myFitLogin: function () {
        $('body').on('click', '.set-myfit', function () {
            if ($('#unique-id-pgp').length > 0) {
                myFitLogin.call(this, true);
            }
        });
    },
    closeModal: ModalLogin.closeModal,
    backtoTop: backtoTop,
    enlargeMobilePGPImages: checkDomForCustomCatFlag
};
